import { render, staticRenderFns } from "./SingleTransportService.vue?vue&type=template&id=c36df36e&scoped=true&"
import script from "./SingleTransportService.vue?vue&type=script&lang=js&"
export * from "./SingleTransportService.vue?vue&type=script&lang=js&"
import style0 from "./SingleTransportService.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleTransportService.vue?vue&type=style&index=1&id=c36df36e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36df36e",
  null
  
)

export default component.exports